import React from 'react';
import PropTypes from 'prop-types';
import Card from '../../../Card/Card';
import Icon from '../../../Icons/Icon';

import * as Styled from './LinkCard.styled';

/**
 * A card with a title and description intended to be rendered within a Link component or anchor tag
 */
const LinkCard = ({ title, description, ...props }) => (
  <Card {...props}>
    <Styled.CardContent>
      <Styled.CopyContainer>
        <Styled.Title>{title}</Styled.Title>
        <Styled.Description>{description}</Styled.Description>
      </Styled.CopyContainer>
      <Styled.IconContainer>
        <Icon name="chevron-right" />
      </Styled.IconContainer>
    </Styled.CardContent>
  </Card>
);

LinkCard.propTypes = {
  /**
   * title of page the link directs to
   */
  title: PropTypes.string.isRequired,
  /**
   * description of the linked page
   */
  description: PropTypes.string.isRequired
};

export default LinkCard;
